import React, { useState, useEffect } from 'react';
import './ResturantSelector.css';
import { useNavigate } from 'react-router-dom';

const RestaurantSelector = () => {
  const [stores, setStores] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    // 1. Get the 'user' string from localStorage
    const userDataString = localStorage.getItem('user');
    
    if (userDataString) {
      try {
        // 2. Parse the string into an object
        const userData = JSON.parse(userDataString);
        
        // 3. Access the 'stores' array
        if (userData && Array.isArray(userData.stores)) {
          setStores(userData.stores);
          
          // Optional: Auto-select the first store if list isn't empty
          if (userData.stores.length > 0) {
            setSelectedId(userData.stores[0].id);
          }
        }
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
      }
    }
  }, []);

  const handleSubmit = () => {
    const selectedStore = stores.find(s => s.id === selectedId);
localStorage.setItem('selectedStore', JSON.stringify(selectedStore));
navigate(`${process.env.PUBLIC_URL}/home`);

  };

  return (
    <div className="modal-container" dir="rtl">
      <div className="selection-card">
        <h2 className="title">اختيار المطعم</h2>
        <p className="subtitle">مرحباً بك في صفحة حسابك</p>

        <div className="options-list">
          {stores.length > 0 ? (
            stores.map((store) => (
              <div
                key={store.id}
                className={`option-item ${selectedId === store.id ? 'active' : ''}`}
                onClick={() => setSelectedId(store.id)}
              >
                <div className="restaurant-info">
                  <span className="res-name">{store.name}</span>
                  {/* Fallback to 'description' or 'category' based on your object structure */}
                  <span className="res-desc">{store.description || store.category}</span>
                </div>
                <div className="logo-wrapper-image">
                  <img src={store.logo} alt={store.name} />
                </div>
              </div>
            ))
          ) : (
            <p>لا توجد مطاعم متاحة</p>
          )}
        </div>

        <button 
          className="submit-btn" 
          onClick={handleSubmit}
          disabled={!selectedId}
        >
          اختيار
        </button>
      </div>
    </div>
  );
};

export default RestaurantSelector;